import { CSSObject } from '@emotion/react'
import { sharedColors } from '../../sharedStyles/colors'

const getTwitterIcons = (isMobile: boolean): CSSObject => ({
  margin: isMobile ? '12px 60px 8px 77px' : '12px 103px 8px 77px',
  padding: '0',
  display: 'flex',
  justifyContent: 'space-between',
  listStyleType: 'none',
  color: sharedColors.medGreyText,
})

const styles = {
  getTwitterIcons,
}

export { styles }
